import script from "./QualificationsForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./QualificationsForm.vue?vue&type=script&lang=ts&setup=true"

import "./QualificationsForm.vue?vue&type=style&index=0&id=45070f84&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45070f84"]])

export default __exports__